import {
  FormErrorWithDiscriminatedField,
  FormSchema,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "shared/components/forms/Select";
import { Field, FieldErrorText } from "shared/components/Spor";

export const StationThreatLevel = () => {
  const { t } = useTranslation();
  const { register, formState } = useFormContext<FormSchema>();
  const fieldErrors: FormErrorWithDiscriminatedField<"threatLevel"> =
    formState.errors.stationForm;

  return (
    <Field invalid={!!fieldErrors?.threatLevel}>
      <Select
        label={t("Trusselnivå")}
        {...register("stationForm.threatLevel")}
        placeholder={t("Velg trusselnivå")}
        invalid={!!fieldErrors?.threatLevel}
      >
        <option value="ALPHA">{t("Alpha")}</option>
        <option value="BRAVO">{t("Bravo")}</option>
        <option value="CHARLIE">{t("Charlie")}</option>
        <option value="DELTA">{t("Delta")}</option>
      </Select>

      <FieldErrorText>{fieldErrors?.threatLevel?.message}</FieldErrorText>
    </Field>
  );
};
